export default __webpack_public_path__ + "static/media/instagram.925fd433.svg";